import styled from 'styled-components';

export const StyledBadge = styled.div`
  display: grid;
  place-content: center;
  width: max-content;
  background-color: var(--c-gray-100);
  border-radius: var(--border-radius);
`;
